import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export default function BarChartComponent({ data }) {
  return (
    <BarChart
      borderRadius={10}
      xAxis={[
        {
          scaleType: "band",
          data: data.map((item) => item.week),
          categoryGapRatio: 0.3,
          barGapRatio: 0.1,
        },
      ]}
      series={[
        {
          data: data.map((item) => item.attendanceRate),
          label: "تعداد تمرین",
        },
        {
          data: data.map((item) => item.engagementRate),
          label: "درصد میانگین عملکرد بازیکنان",
        },
      ]}
      height={400}
    />
  );
}
